import React, { useState, useEffect } from 'react';
import './SessionList.css';

const SessionList = ({ organizerId, onSelectSession }) => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadSessions();
  }, [organizerId]);

  const loadSessions = async () => {
    try {
      const response = await fetch(`/api/organizer/${organizerId}/sessions`, {
        credentials: 'include',
      });
      if (response.ok) {
        const data = await response.json();
        setSessions(data);
      } else {
        setError('Failed to load sessions');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      draft: { label: 'Draft', class: 'badge-draft' },
      active: { label: 'Active', class: 'badge-active' },
      completed: { label: 'Completed', class: 'badge-completed' },
    };
    const statusInfo = statusMap[status] || { label: status, class: 'badge-default' };
    return <span className={`status-badge ${statusInfo.class}`}>{statusInfo.label}</span>;
  };

  if (loading) {
    return <div className="loading">Loading sessions...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (sessions.length === 0) {
    return (
      <div className="empty-state">
        <p>No sessions yet. Create your first screening session!</p>
      </div>
    );
  }

  return (
    <div className="session-list">
      <div className="list-header">
        <h3>Your Screening Sessions</h3>
        <button onClick={loadSessions} className="refresh-btn">
          Refresh
        </button>
      </div>

      <div className="sessions-grid">
        {sessions.map((session) => (
          <div
            key={session.session_id}
            className="session-card"
            onClick={() => onSelectSession(session.session_id)}
          >
            <div className="card-header">
              <h4>{session.job_title || 'Untitled Session'}</h4>
              {getStatusBadge(session.status)}
            </div>
            <div className="card-body">
              <div className="card-info">
                <span className="info-label">Persona:</span>
                <span className="info-value">{session.persona}</span>
              </div>
              <div className="card-info">
                <span className="info-label">Invites:</span>
                <span className="info-value">{session.invite_count || 0}</span>
              </div>
              <div className="card-info">
                <span className="info-label">Responses:</span>
                <span className="info-value">{session.response_count || 0}</span>
              </div>
              {session.created_at && (
                <div className="card-info">
                  <span className="info-label">Created:</span>
                  <span className="info-value">
                    {new Date(session.created_at).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
            <div className="card-footer">
              <button className="view-btn">View Details</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SessionList;

